import admin from "./admin/index.js"; // 系统设置
import consignor from "./consignor/index.js"; // 委托方
import organization from "./organization/index.js"; //作业方
import cases from "./cases/index.js"; //案件管理
import casesHandled from "./casesHandled/index.js"; //案件管理
import casesPending from "./casesPending/index.js"; //案件管理
import reportDownload from "./reportDownload/index.js"; //案件管理
import config from "./config/index.js"; //调查项配置
export default [
  {
    path: "/home",
    name: "home",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["首页"],
      permissionsPath: "system"
    },
    component: () => import(/* webpackChunkName: "index" */ "@/views/home.vue")
  },
  ...admin,
  ...consignor,
  ...organization,
  ...cases,
  ...casesHandled,
  ...casesPending,
  ...reportDownload,
  ...config
];
